import { render } from "./SendersList.vue?vue&type=template&id=d7b7a78c"
import script from "./SendersList.vue?vue&type=script&lang=js"
export * from "./SendersList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__